import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { TSupportedEntity } from "utils/app-search-utils";

export const getEntityName = (item: TSupportedEntity): string => {
  let output: string;

  if (item instanceof racehorse360.Trainer) {
    output = `${item.firstName} ${item.lastName}`;
  } else if (item instanceof racehorse360.Horse) {
    output = item.name;
  } else if (item instanceof racehorse360.StallApplication) {
    output = item.contactFullName;
  }

  return output;
};
